import { createContext } from 'react'
import { ICampaignFilterContext } from '../interfaces'

export const CampaignFilterContext = createContext<
   ICampaignFilterContext | undefined
>(undefined)
